// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js-chunks/resources/" + ({"0":"bundleBuyCardComponent","195":"cartBanner","280":"cartFlyout","872":"buyCardComponent"}[chunkId] || chunkId) + ".js";
};